import { Injectable } from '@angular/core';
import { CanDeactivate, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { MessageBoxType } from '../dialog/message-box-content/message-box-content.component';
import { DialogService } from '../dialog/service/dialog.service';

export interface CanChildDeactivate {
  hasUnsavedChanges?: () => boolean;
}

export interface CanComponentDeactivate {
  hasUnsavedChanges(): boolean;
  getUnsavedMessage(): string;
}

@Injectable({ providedIn: 'root' })
export class CanDeactivateComponent implements CanDeactivate<CanComponentDeactivate> {
  constructor(private dialogService: DialogService) {}
  canDeactivate(component: CanComponentDeactivate): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve) => {
      if (component.hasUnsavedChanges()) {
        const message = component.getUnsavedMessage();
        const result = await this.dialogService.showMessageBox('', message, MessageBoxType.YesNo, true);
        resolve(result);
      }
      resolve(true);
    });
  }
}
